import styled from 'styled-components';

export const StyledArticleFilePreview = styled.a`
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.75rem;
    padding: 0.5rem 0.85rem;
    border: ${(props) => props.theme.DefaultBorder};
    border-radius: 6px;
    background: #f5f5f5;
    color: ${(props) => props.theme.TextColor};
    max-width: 100%;

    span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    &:hover {
        color: ${(props) => props.theme.PrimaryColor};
    }
`;
